import { yup } from 'common/validation/initYup';

export const WidgetActivitiesSearchSchema = yup.object({});
